import {
  ClassesIllustration,
  Grid,
  GridColumn,
  GridRow,
  OverviewIllustration,
  PdfIcon,
  SubjectIllustration,
} from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { BaseOutlet } from '../../../../components/BaseOutlet/BaseOutlet';
import { EvaluatePlannedDeputateStats } from '../../../../components/Deputate/EvalutateDeputateStats/EvaluatePlannedDeputateStats';
import { IconMenu } from '../../../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const DeputateEvaluatePlannedPage = ({ baseSlug }: { baseSlug: string }) => {
  const { t } = useTranslation();
  const { teacherUuid, classUuid, subjectUuid } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = usePermissionChecker();

  const showMenu = !teacherUuid && !classUuid && !subjectUuid;

  return (
    <Page
      isForbidden={!permissions?.canReadDeputate()}
      title={showMenu ? t('routes.deputate.evaluate.planned.title') : undefined}
    >
      {showMenu && (
        <Grid>
          <GridRow spacingBottom={'m'}>
            <GridColumn width={6}>
              <IconMenu variant='tabs' hasMarginBottom columns={4}>
                <IconMenuItem
                  label={t('deputate.menuItems.overview')}
                  icon={<OverviewIllustration />}
                  bubbleType={4}
                  onClick={() => navigate('/' + baseSlug + '/' + t('routes.deputate.evaluate.planned.slug'))}
                  active={location.pathname.endsWith(t('routes.deputate.evaluate.planned.slug'))}
                />
                <IconMenuItem
                  label={t('deputate.menuItems.classes')}
                  icon={<ClassesIllustration />}
                  bubbleType={3}
                  onClick={() => navigate(t('routes.deputate.byClass.slug'))}
                  active={location.pathname.endsWith(t('routes.deputate.byClass.slug'))}
                />
                <IconMenuItem
                  label={t('deputate.menuItems.subject')}
                  icon={<SubjectIllustration />}
                  bubbleType={5}
                  onClick={() => navigate(t('routes.deputate.evaluate.bySubject.slug'))}
                  active={location.pathname.endsWith(t('routes.deputate.evaluate.bySubject.slug'))}
                />
                <IconMenuItem
                  label={t('pdf.title', { count: 2 })}
                  icon={<PdfIcon />}
                  bubbleType={10}
                  onClick={() => navigate(t('routes.deputate.evaluate.reports.slug'))}
                  active={location.pathname.endsWith(t('routes.deputate.evaluate.reports.slug'))}
                />
              </IconMenu>
            </GridColumn>
            <GridColumn width={6}>
              <EvaluatePlannedDeputateStats />
            </GridColumn>
          </GridRow>
        </Grid>
      )}
      <BaseOutlet />
    </Page>
  );
};
